<template>
    <div>
        <div v-if="!showLoading">
            <div class="container" >
                <div style="width: 100%; height: 472vw; position: relative;">
                    <img style="width: 100vw;" src="../../assets/miqu/img_bottom.png" />
                    <div style="width: 100vw; height: 100px; position: absolute; bottom: 0px;" @click="onPress"></div>
                </div>
                <img style="width: 100vw; position: fixed; top: 0; left: 0; z-index: 99;" src="../../assets/miqu/img_top.png" @click="onPress" />
            </div>

            <div v-if="showJump" style="width: 100vw; height: 100vh; background-color:rgba(0, 0, 0, 0.6); position: fixed; top: 0; z-index: 100">
                <img style="right: 0px; float: right; width: 60vw; height: 24vw;" src="../../assets/tianmi/download_top.png">
            </div>
        </div>

        <div v-else class="loading">
            <!-- <img style="width: 20vw; height: 20vw; margin-left: 40vw; margin-top: 40vh;" src="../../assets/profit/loading.gif" /> -->
        </div>
    </div>
</template>


<script>
import axios from 'axios';
import { is_weixin, isIos, is_qq } from '../../common/functions';

const url_android = 'https://app-test-1301744297.file.myqcloud.com/file/miqu/miqu_sh_2.60.0.apk';
// const url_ios = 'http://fir.csjywlkj.cn/qy8bw2';
const url_ios = 'https://apps.apple.com/cn/app/%E8%A7%85%E8%B6%A3-%E5%8F%91%E7%8E%B0%E4%B8%96%E7%95%8C%E7%9A%84%E7%B2%BE%E5%BD%A9/id6449919326';

export default {
    data() {
        return {
            index: 1,
            inWeiXinOrQQ: false,
            showJump: false,
            showLoading: true,

            token: ''
        };
    },

    created() {
        document.title = "App下载";
        this.inWeiXinOrQQ = is_weixin() || is_qq();
        // this.inWeiXinOrQQ = true;

        const url = window.location.href;
        const z = url.split('?');
        let p = {};

        try {
            const k = z[1].split('&');
            k.forEach(item => {
                const m = item.split('=');
                p[m[0]] = m[1];
            })
            this.token = p.id;
        } catch(e) {}

        // console.log('this token value si - -- - - --- ----->', !!this.token);
        if (!!this.token) {
            this.checkURLAvailible();
        } else {
            this.showLoading = false;
            // window.location.href = '/404';
        }
    },

    mounted() {
        
    },

    methods: {
        onPress() {
            if (is_weixin() && !isIos()) {
                // alert('请点击右上角使用外部浏览器打开后再进行下载!');
                this.showJump = true;
            } else {
                if (isIos()) {
                    window.location.href = url_ios;
                } else {
                    window.location.href = url_android;
                }
            }
        },

        checkURLAvailible() {
            const url = 'https://tmapi.csjywlkj.cn/callback-other/web-verify-code';
            let params = {
                code: this.token
            };
            axios.post(url, params).then(res => {
                const par = JSON.parse(res.data);
                // console.log('get url availible si - - -- - - ------>', par);
                if (par.code == -200) {
                    window.location.href = '/404';
                } else {
                    this.showLoading = false;
                }
            })
        }
    }
}
</script>


<style scoped>
.container {
    width: 100%;
    height: 100%;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.img {
    position: absolute;
    width: 100%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 60s;
}

.button {
    width: 70%;
    height: 60px;
    border-radius: 30px;
    margin-bottom: 20%;
    align-items: center;
    justify-content: center;
    display: flex;

    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 1.4s;
    animation-name: button;
}

.loading {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: white;
}

@keyframes button {
    0% { width: 200px; height: 50px; }
    50% { width: 260px; height: 60px; }
    100% { width: 200px; height: 50px; }
}
</style>